module.exports = __webpack_public_path__ + "img/47.3.TP.d113b7c0.png";